<template>
    <gat-form>
        <v-card>
                <v-layout row wrap >
                    <gat-edit v-model="transToEdit.TRANSACTION_DATE" label="Date" :dateEdit="true" size="s" />
                    <gat-edit v-model="transToEdit.SUPPLIER" label="Supplier" size="m" :autofocus="true" />
                    <gat-edit v-model="transToEdit.AMOUNT" dataType="number" :decimals="2" label="Amount" size="s" />
                    <gat-edit v-model="transToEdit.DESCRIPTION" label="Description" size="l" />
                    <gat-select v-model="transToEdit.CATEGORY_ID" label="Category" :items="$store.state.categories" textFieldName="fullName" codeFieldName="CAT_ID" size="m" />                    
                
                </v-layout>
                <v-btn flat color="primary" :disabled="!canSave" @click="saveExpectedTransaction">Save</v-btn>         
                <v-btn flat  v-if="canDelete" @click="deleteExpectedTransaction">Delete</v-btn>         
        </v-card>        
    </gat-form>
</template>

<script>
import GatEdit from '../../../GatComponents/GatEdit.vue'
import GatForm from '../../../GatComponents/GatForm.vue'
import GatSelect from '../../../GatComponents/GatSelect.vue'
export default {
    props: {
        expectedTransaction: {
            type: Object,
            required: true
        }
    },
    components: { GatForm, GatEdit, GatSelect },
    name: "ExpectedTransactionForm",
    data() {
        return {
            transToEdit:{
                TRANSACTION_DATE: null,
                SUPPLIER: null,
                AMOUNT: null,
                DESCRIPTION: "",
                CATEGORY_ID: null,
                ID: null,
                TRANSACTION_ID: null}
        };
    },


    mounted() {
        // console.log('mounted form.prop->expectedTransaction: '+this.expectedTransaction.ID); 
        if(this.expectedTransaction.ID){
            this.transToEdit = Object.assign({},this.expectedTransaction);
        } else{
            this.transToEdit.TRANSACTION_DATE = new Date();
        }
    },

    watch: {
        expectedTransaction(newVal) {        
            // console.log('watch form.prop->expectedTransaction: '+oldVal.ID +' -> '+ newVal.ID);
            if(newVal.ID){
                this.transToEdit = Object.assign({},newVal);
            }     else{
            this.transToEdit.TRANSACTION_DATE = new Date();
        }                    
        }
    },

    computed:{
        canDelete(){
            return this.expectedTransaction.ID>0;
        },
        canSave(){
            //if update, one of the fields must have changed
            if(this.expectedTransaction.ID>0){
                return JSON.stringify(this.transToEdit) != JSON.stringify(this.expectedTransaction);
            }
                
            return this.transToEdit.TRANSACTION_DATE && this.transToEdit.SUPPLIER && this.transToEdit.AMOUNT;
        }
    },

    methods: {
        deleteExpectedTransaction() {
            this.$emit('deleteClicked',this.transToEdit);
        },

        saveExpectedTransaction() {
            this.$emit('save',this.transToEdit);
        }
    }
    
}
</script>

<style>

</style>